








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Navigation extends Vue {
  public selectWork(id: number) {
    this.$store.dispatch('selectWork', id);
    // this.$store.dispatch('requestData');
  }
}
